import { render, staticRenderFns } from "./ShoppingInsights.vue?vue&type=template&id=22c06a92&"
import script from "./ShoppingInsights.vue?vue&type=script&lang=js&"
export * from "./ShoppingInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports